import { Braces } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Label } from "@/components/ui/label";
import { SERVICE_LINES, AUDIENCE_STREAMS, REGIONS } from "@/lib/constants";

const OVERRIDES = [
  { k: "service_line", label: "Service line", options: SERVICE_LINES.map((v) => ({ value: v, label: v })) },
  { k: "audience_stream", label: "Audience stream", options: AUDIENCE_STREAMS },
  { k: "region", label: "Region", options: REGIONS.map((v) => ({ value: v, label: v })) },
];

export const SessionContextChip = ({ userId, context, overrides, onOverride }) => (
  <Popover>
    <PopoverTrigger asChild>
      <Button variant="secondary" size="sm" data-testid="session-context-chip"><Braces className="!h-4 !w-4" /> Session context</Button>
    </PopoverTrigger>
    <PopoverContent align="end" className="w-[360px] rounded-xl" data-testid="session-context-panel">
      <p className="text-sm font-medium">Passed to the Agentic Brain for this run</p>
      <p className="mt-1 text-xs text-muted-foreground">Only these seven keys and your hub user ID. Never client, contact or deal details.</p>
      <pre className="mt-3 max-h-56 overflow-auto rounded-lg bg-muted p-3 text-xs leading-relaxed" data-testid="session-context-json">
        {JSON.stringify({ customUserId: userId, customSessionContext: context }, null, 2)}
      </pre>
      <p className="mt-4 text-sm font-medium">Change for this run only</p>
      <div className="mt-2 grid gap-3">
        {OVERRIDES.map(({ k, label, options }) => (
          <div key={k} className="grid grid-cols-[120px_1fr] items-center gap-2">
            <Label htmlFor={`override-${k}`} className="text-xs">{label}</Label>
            <Select value={overrides[k] || "default"} onValueChange={(v) => onOverride(k, v === "default" ? null : v)}>
              <SelectTrigger id={`override-${k}`} className="h-9 rounded-xl" data-testid={`override-${k}`}><SelectValue /></SelectTrigger>
              <SelectContent className="rounded-xl">
                <SelectItem value="default">My default</SelectItem>
                {options.map((o) => <SelectItem key={o.value} value={o.value}>{o.label}</SelectItem>)}
              </SelectContent>
            </Select>
          </div>
        ))}
      </div>
    </PopoverContent>
  </Popover>
);
